import { render, staticRenderFns } from "./policyInfo.vue?vue&type=template&id=3466b470&scoped=true"
import script from "./policyInfo.vue?vue&type=script&lang=js"
export * from "./policyInfo.vue?vue&type=script&lang=js"
import style0 from "./policyInfo.vue?vue&type=style&index=0&id=3466b470&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3466b470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3466b470')) {
      api.createRecord('3466b470', component.options)
    } else {
      api.reload('3466b470', component.options)
    }
    module.hot.accept("./policyInfo.vue?vue&type=template&id=3466b470&scoped=true", function () {
      api.rerender('3466b470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/policyInfo.vue"
export default component.exports